<template>
    <v-card flat style="width:100%;" tile>
        <v-toolbar color="#fff" flat>
            <v-text-field
                    v-bind="{value}"
                    @input="val => commentSearchTerm = val"
                    clearable
                    @keyup.enter="searchCommentsByTerm"
                    @click:clear="clearCmtSearchTerm"
                    background-color="#f4f4f4"
                    class="pt-2 search-box--height"
                    flat
                    height="41"
                    placeholder="Search Here"
                    solo
            />
            <v-btn
                    :class="{'pointer-wait':!commentsReady}"
                    :ripple="false"
                    @click="searchCommentsByTerm"
                    color="bindezcolor"
                    dark
                    depressed
                    small
            >
                <span class="font-weight-regular text-capitalize" style="font-size: 14px;">Search</span>
            </v-btn>

            <v-spacer></v-spacer>
            <!-- v-model="addTagMenu" -->
            <v-menu
                    :disabled="isPostReadOnly"
                    class="pr-1"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-width="300"
                    offset-x
                    v-model="buzzSentimentMenu"

            >
                <v-btn :disabled="isPostReadOnly" :ripple="false" icon slot="activator" small>
                    <v-img
                            :class="{'pointer-wait':isPostReadOnly}"
                            width="18"
                            height="18"
                            contain
                            :src="buzzSentimentIconPath"
                    >
                    </v-img>
                </v-btn>
                <v-card class="pa-3" flat>
                    <v-select
                            :disabled="!selectedComments.length"
                            :class="selectBorder(buzzSentiment)"
                            :color="$options.commentColor[buzzSentiment]"
                            :items="$options.items"
                            class="pt-2 app-compo-selector"
                            flat
                            height="41"
                            item-text="name"
                            item-value="value"
                            label="Select Sentiment"
                            solo
                            style="font-size: 14px; margin-right: -7px;"
                            v-model="buzzSentiment"
                    >
                        <template slot="selection" slot-scope="{item}">
                            <span :style="{color: $options.commentColor[item.value]}" style="font-size: 14px;">{{item.name}}</span>
                        </template>
                    </v-select>
                    <v-layout justify-center>
                        <v-btn @click="updateBuzzSentiment" color="bindezcolor" dark>
                            <span class="text-capitalize">Update Sentiments</span>
                        </v-btn>
                        <v-btn @click="cancelUpdateBuzzSentiment" color="secondarycolor" dark>
                            <span class="text-capitalize">Cancel</span>
                        </v-btn>
                    </v-layout>
                </v-card>
            </v-menu>
            <v-divider vertical inset></v-divider>
            <v-menu
                    :disabled="isPostReadOnly"
                    class="pl-1"
                    :close-on-click="false"
                    :close-on-content-click="false"
                    :nudge-width="250"
                    offset-x
                    v-model="addTagMenu"
            >
                <v-btn :disabled="isPostReadOnly" :ripple="false" icon slot="activator" small>
                    <v-icon>local_offer</v-icon>
                </v-btn>
                <v-card class="pa-3" flat>
                    <span v-show="selectedComments.length < 1 && warningMsg" style="color: #EB2929;">
                        {{warningMsg}}
                    </span>
                    <v-combobox
                            :items="fbCommentsTags"
                            @keyup.enter="addNewTagToSelectedComments"
                            background-color="#f5f5f5"
                            flat
                            label="Add Tag"
                            solo
                            v-model="newTag"
                    ></v-combobox>
                    <v-layout justify-center>
                        <v-btn @click="addNewTagToSelectedComments" color="bindezcolor" dark>
                            <span class="text-capitalize">Add Tag</span>
                        </v-btn>
                        <v-btn @click="cancelAddingNewTag" color="secondarycolor" dark>
                            <span class="text-capitalize">Cancel</span>
                        </v-btn>
                    </v-layout>
                </v-card>
            </v-menu>
            <v-spacer v-if="fitByCat"></v-spacer>
            <v-select
                    :class="selectBorder(filterBy)"
                    :color="$options.commentColor[filterBy]"
                    :items="$options.filterBySentiment"
                    @change="filterByCategory"
                    class="pt-2 app-compo-selector"
                    flat
                    height="41"
                    item-text="name"
                    item-value="value"
                    placeholder="Sentiment"
                    solo
                    style="font-size: 14px; margin-right: -7px;"
                    v-if="fitByCat"
                    v-model="filterBy"
            >
                <template slot="selection" slot-scope="{item}">
                    <span :style="{color: $options.commentColor[item.value]}" style="font-size: 14px;">{{item.name}}</span>
                </template>
            </v-select>
        </v-toolbar>
        <v-divider></v-divider>
        <div class="px-2 pt-1" v-if="commentsReady">
            <v-layout
                    :key="index"
                    list__item-bottom-seperator
                    px-2
                    row
                    v-for="(comment,index) in comments"
            >
                <v-flex align-self-start d-flex xs2>
                    <v-checkbox
                            :ripple="false"
                            :value="comment.id"
                            class="custom-checkbox-size"
                            color="bindezcolor"
                            hide-details
                            style="width: 10px;"
                            v-model="selectedComments"
                            :disabled="isPostReadOnly"
                    ></v-checkbox>
                    <v-icon size="60">account_circle</v-icon>
                </v-flex>
                <v-flex pl-0 xs10>
                    <v-layout row wrap>
                        <v-flex d-flex justify-space-between pt-3 xs12>
                            <a
                                    @click="routePage(comment)"
                                    class="body-1"
                                    style="text-decoration: none; color:#000;"
                            >Facebook User</a>
                            <div class="text-xs-right">
                                <span class="caption description--color">{{ comment.created_time | formatDate}}</span>
                            </div>
                        </v-flex>
                        <v-flex align-self-start pt-0 xs12>
                            <p
                                    class="zawgyi caption mb-0 comment__body--work-break"
                            >{{comment._uni_message | fromUnicodeToZawgyi}}</p>
                        </v-flex>

                        <v-flex xs9>
                            <CommentTag :isPostReadOnly="isPostReadOnly" @error="errorHandler" :comment_id="comment.id" :key="comment.id" :tags="comment.tags"/>
                        </v-flex>

                        <v-flex style="padding-left: 35px;" xs3>
                            <v-select
                                    :disabled="isPostReadOnly"
                                    :class="selectBorder(comment.category)"
                                    :color="comment.category"
                                    :items="$options.items"
                                    @change="updateSentiment({comment_id:comment.id ,sentiment:comment.category})"
                                    class="app-compo-selector"
                                    dense
                                    flat
                                    height="35"
                                    hide-details
                                    item-text="name"
                                    item-value="value"
                                    solo
                                    v-model="comment.category"
                            >
                                <template slot="selection" slot-scope="{item}">
                                    <span :style="{color:isPostReadOnly ? 'currentColor' : $options.commentColor[item.value]}"  style="font-size: 14px;">{{item.name}}</span>
                                </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
            <div
                    class="text-xs-center d-flex fill-height align-center"
                    style="height: 400px"
                    v-if="comments.length === 0"
            >
                <span class="font-weight-bold display-1" style="color:#AFBAC8">No Comments Found</span>
            </div>
        </div>
        <v-layout align-center fill-height text-xs-center v-else>
            <v-flex>
                <v-progress-circular color="bindezcolor" indeterminate/>
            </v-flex>
        </v-layout>
    </v-card>
</template>

<script>
    /* eslint-disable */
	import moment from "moment";
	import {mapMutations, mapActions, mapState} from "vuex";
	import CommentTag from "../components/CommentTag";
	import AppBindezPagination from "@/components/AppBindezPagination";
    import authCurrentUser from "@/mixins/authCurrentUser";

	export default {
		props: {
			comments: {
				type: Array
			},
			fitByCat: {
				default: false,
				type: Boolean
			},
			commentsCount: {
				type: Number,
				required: true
			},
			commentsReady: {
				default: true,
				type: Boolean,
				required: true
			},
            isPostReadOnly:{
				type: Boolean
            },
            value:{
				type: String
            }
		},
		name: "AppComments",
		data() {
			return {
				page: 1,
				newTag: "",
				filterBy: undefined,
				addTagMenu: false,
                warningMsg: undefined,
				testList: ["one", "two", "three"],
				skipCount: 5,
				perPage: 10,
                buzzSentimentMenu: false,
                buzzSentiment:undefined,
                commentSearchTerm:"",
			};
		},
        // filterBySentiment, items, commentColor are not reactive.They are static value,
		filterBySentiment: [
			{name: "All Sentiments", value: null, available: true},
			{name: "Positive", value: "positive", available: true},
			{name: "Negative", value: "negative", available: true},
			{name: "Neutral", value: "neutral", available: true},
			{name: "Interest", value: "interest", available: true},
			{name: "Other", value: "other", available: true}
		],

		commentColor: {
			negative: "#EB2929",
			positive: "#1AB177",
			neutral: "#EAC82A",
			interest: "#1F65C5",
			other: "#9e9e9e"
		},

		items: [
			{name: "Positive", value: "positive", available: true},
			{name: "Negative", value: "negative", available: true},
			{name: "Neutral", value: "neutral", available: true},
			{name: "Interest", value: "interest", available: true},
			{name: "Other", value: "other", available: true}
		],

        // static values end here.

        mixins:[authCurrentUser],

		components: {
			CommentTag,
			AppBindezPagination
		},

		methods: {
			...mapMutations([
				"setSelectedMonitorComments",
				"setPreviousRoute",
			]),

			...mapMutations("sentiment", [
				"setCurrentPage",
				"setMonitorAllComments"
            ]),

			...mapMutations("mention", [
				"setMonitorSinglePostComments",
				"setMonitorSinglePostCommentsCount"
			]),

			...mapActions([
				"createCommentTags",
				"updateCommentSentiment",
				"fetchFacebookSummary"
			]),

            ...mapMutations('error',[
            	"setErrorDialogMessage",
                "setErrorDialogStatus",
            ]),

			searchCommentsByTerm() {
				if (!this.commentsReady) return;
				this.$ua.trackEvent("Search Comments By Term", "click");
				this.addTagMenu = false;
				this.selectedComments = [];
				this.$emit("input", this.commentSearchTerm);
				this.$emit("searchCommentsByTerm");
			},

			updateBuzzSentiment() {
				if (!this.selectedComments.length || !this.buzzSentiment) return;
				let data = this.selectedComments.map(cmt => ({
					monitor_uuid: this.$route.params.monitor_uuid,
					comment_id: cmt,
					sentiment: this.buzzSentiment
				}));
				this.updateCommentSentiment(data)
                    .then(() => {
					this.$ua.trackEvent("Comment","click",`${this.authenticatedUser.email || 'User' } update ${this.$route.params.monitor_uuid}'s buzz ${this.selectedComments.length} comments sentiment into ${this.buzzSentiment}`);
					this.comments.forEach(comment => {
                        if(this.selectedComments.includes(comment.id)) comment.category = this.buzzSentiment;
                    });
				})
                .catch(_ => {
                	this.setErrorDialogStatus(true);
                	this.setErrorDialogMessage("Error occur while performing buzz sentiment actions.")
                })
			},

			cancelUpdateBuzzSentiment(){
				this.buzzSentimentMenu = false;
				this.buzzSentiment= undefined;
				this.selectedComments = [];
            },

			updateSentiment({comment_id, sentiment}) {
				let {monitor_uuid} = this.$route.params;
				this.updateCommentSentiment({
					monitor_uuid,
					comment_id,
					sentiment
				}).then(({data}) => {
					if(data.success && data.success.message !== 'Successfully Updated Sentiment'){
						this.setErrorDialogStatus(true);
						this.setErrorDialogMessage(data.success.message);
                    }
					this.$ua.trackEvent("Comment", "select", `${this.authenticatedUser.email || 'User' } update monitor(${this.$route.params.monitor_uuid})'s comment(${comment_id}) sentiment(${sentiment})`);
				}).catch(_ => {
					this.setErrorDialogStatus(true);
					this.setErrorDialogMessage("Error occur when updating comment's sentiment.");
                });
			},

			addNewTagToSelectedComments() {
				let newlyAddedTags = this.newTag.toLowerCase();
				let existedTag = this.tagsData.find(item => item.tag === newlyAddedTags);
				if (!newlyAddedTags || this.selectedComments.length < 1) {
					this.warningMsg = "Please Select Comment.";
					return;
				}
				let commentsToAddTags = this.comments.filter(comment => this.selectedComments.includes(comment.id) && !comment.tags.includes(newlyAddedTags));
                let data = commentsToAddTags.map(comment => {
                	let newTags = [...comment.tags, newlyAddedTags];
                	return{
                		comment_id: comment.id,
                        monitor_uuid: this.$route.params.monitor_uuid,
                        tags: newTags
                    }
                });
				if (data.length) {
					this.createCommentTags(data)
						.then(_ => {
							this.$ua.trackEvent("Comment", "click", `${this.authenticatedUser.email || 'User'} add ${this.newTag} to monitor(${this.$route.params.monitor_uuid})'s ${data.length} comments`);
							commentsToAddTags.forEach(comment => {
								comment.tags.push(newlyAddedTags); //updating comment with new tag by reference.
							});
							existedTag ? existedTag.count += 1 : this.tagsData.push({tag: newlyAddedTags, count: 1});
						});
				}
			},

			cancelAddingNewTag() {
				this.addTagMenu = false;
				this.selectedComments = [];
				this.warningMsg = undefined;
			},

			filterByCategory() {
				this.$ua.trackEvent("Filter Comments", "select", "Filter Comments By Sentiment");
				this.$emit("filterByCategory", this.filterBy);
			},

			selectBorder(category) {
				if(this.isPostReadOnly) return "bindez__select__disabled";
				if (!category) return `bindez__select`;
				return `bindez__${category}__select`;
			},

			routePage(cmt) {
				if (!this.disableCmtLink && this.$route.name === "postdetail") {
					window.open(`//facebook.com/${cmt.id}`, "_blank");
				} else if (this.$route.name === "sentiment") {
					let data = {comments: [cmt], count: 1};
					this.setMonitorSinglePostComments(data);
					this.setMonitorSinglePostCommentsCount(data);
					this.setPreviousRoute("sentiment");
					this.$router.push({
						name: "postdetail",
						params: {
							post_id: cmt.post_id,
							monitor_uuid: this.$route.params.monitor_uuid
						}
					});
				}
			},

            clearCmtSearchTerm(){
				this.commentSearchTerm = "";
				this.$emit("input", this.commentSearchTerm);
				this.searchCommentsByTerm();
            },

            errorHandler(val){
				this.errorDialog = true;
				this.errorDialogTitle = val;
            }
		},

		computed: {
			...mapState([
                "previousRoute",
                "selectedMonitorComments"
            ]),

            ...mapState({
               disableCmtLink:state => state.monitor.disable_comment_link
            }),

            ...mapState({
                tagsData: state => state.facebookSummary.fbcomments.tags_cloud_data
            }),

			...mapState("sentiment", ["currentPage"]),

            ...mapState("mention",[
            	"monitorSinglePost"
            ]),

			fbCommentsTags() {
				return this.tagsData.map(item => item.tag);
			},

			pageLength() {
				return Math.ceil(this.commentsCount / 10);
			},

            selectedComments:{
				get(){
					return this.selectedMonitorComments
                },
                set(comment){
					this.setSelectedMonitorComments(comment);
                }
            },

            buzzSentimentIconPath(){
				return this.isPostReadOnly ? require('@/assets/buzz-sentiment-disabled.svg') : require('@/assets/buzz-sentiment.svg');
            }
		},

		filters: {
			formatDate(raw) {
				return moment(raw).format("h:mm a D MMMM, YYYY");
			},
		},

		created() {
			if (this.currentPage && this.$route.name === "sentiment")
				this.page = this.currentPage;
		}
	};
</script>

<style>
    .app-compo-selector.v-select.v-text-field--solo .v-input__slot {
        min-height: 25px;
    }

    .v-btn.v-btn--small,
    .v-btn.v-btn--large {
        height: 41px;
    }

    .bindez__select.v-text-field--solo .v-input__slot {
        border: 1px solid #9e9e9e;
    }

    .bindez__negative__select.v-text-field--solo .v-input__slot {
        border: 1px solid #eb2929;
    }

    .bindez__positive__select.v-text-field--solo .v-input__slot {
        border: 1px solid #1ab177;
    }

    .bindez__neutral__select.v-text-field--solo .v-input__slot {
        border: 1px solid #eac82a;
    }

    .bindez__interest__select.v-text-field--solo .v-input__slot {
        border: 1px solid #1f65c5;
    }

    .bindez__other__select.v-text-field--solo .v-input__slot {
        border: 1px solid #9e9e9e;
    }

    .bindez__select__disabled.v-text-field--solo .v-input__slot{
        border: 1px solid rgba(0,0,0,0.3);
    }

    .comment__body--work-break {
        overflow-wrap: break-word;
        word-break: break-all;
    }

    .pointer-wait {
        cursor: no-drop;
    }
</style>
